<template>
  <div class="cv-form-container cmn-card user-detail" v-if="resume">
    <!-- Card 1: Profile & Personal Info -->
    <div class="cv-form-section">
      <div class="resume-profile-header">
        <div class="author-avatar">
          <img
            v-if="resume.img_path || resume.profile_image"
            :src="resume.img_path || resume.profile_image"
            alt="Profile Avatar"
            class="author-avatar-img"
            width="50"
            height="50"
          />
          <app-icon
            v-else
            name="user"
            size="50"
          />
        </div>
        <div class="resume-header-info">
          <h2 class="resume-name">{{ resume.name }}</h2>
          <p class="resume-position" v-if="resume.position">{{ resume.position }}</p>
        </div>
      </div>

      <div class="cv-section-header">
        <h2 class="cv-section-title">ကိုယ်ရေးအချက်အလက်များ</h2>
      </div>

      <div class="cv-form-grid">
        <div class="detail-block-list">
          <div class="form-item">
            <span class="form-label flex-1">ကျား/မ</span>
            <div class="flex-1">
              <span class="form-value" v-if="resume.gender == 1">ကျား</span>
              <span class="form-value" v-else-if="resume.gender == 2">မ</span>
              <span class="form-value" v-else>-</span>
            </div>
          </div>

          <div class="form-item">
            <span class="form-label flex-1">မှတ်ပုံတင်အမှတ်</span>
            <span class="form-value flex-1">{{ resume.nrc_number || '-' }}</span>
          </div>

          <div class="form-item">
            <span class="form-label flex-1">လူမျိုး</span>
            <span class="form-value flex-1">{{ resume.nationality || '-' }}</span>
          </div>
        </div>

        <div class="detail-block-list">
          <div class="form-item">
            <span class="form-label flex-1">ကိုးကွယ်သည့်ဘာသာ</span>
            <span class="form-value flex-1">{{ resume.religion || '-' }}</span>
          </div>

          <div class="form-item">
            <span class="form-label flex-1">မွေးသက္ကရာဇ်</span>
            <span class="form-value flex-1">{{ resume.date_of_birth || '-' }}</span>
          </div>

          <div class="form-item">
            <span class="form-label flex-1">အိမ်ထောင်ရေးအခြေအနေ</span>
            <div class="flex-1">
              <span class="form-value" v-if="resume.marital_status == 1">အိမ်ထောင်ရှိ</span>
              <span class="form-value" v-else-if="resume.marital_status == 2">အိမ်ထောင်မရှိ</span>
              <span class="form-value" v-else>Single</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 2: Contact Information -->
    <div class="cv-form-section">
      <div class="cv-section-header">
        <h3 class="cv-section-title">ဆက်သွယ်ရန်အချက်အလက်</h3>
      </div>

      <div class="detail-block-list">
        <div class="form-item" v-if="resume.email">
          <span class="form-label flex-1">အီးမေးလ်လိပ်စာ</span>
          <span class="form-value flex-1">{{ resume.email }}</span>
        </div>

        <div class="form-item" v-if="resume.phone_number">
          <span class="form-label flex-1">ဖုန်းနံပါတ်</span>
          <span class="form-value flex-1">{{ resume.phone_number }}</span>
        </div>

        <div class="form-item" v-if="resume.contact_address">
          <span class="form-label flex-1">လက်ရှိဆက်သွယ်ရမည့် လိပ်စာ</span>
          <span class="form-value flex-1">{{ resume.contact_address }}</span>
        </div>

        <div class="form-item" v-if="resume.permanent_address">
          <span class="form-label flex-1">အမြဲတမ်း နေရပ်လိပ်စာ</span>
          <span class="form-value flex-1">{{ resume.permanent_address }}</span>
        </div>

        <div class="form-item" v-if="resume.linkin">
          <span class="form-label flex-1">LinkedIn Account</span>
          <span class="form-value flex-1">{{ resume.linkin }}</span>
        </div>

        <div class="form-item" v-if="resume.facebook">
          <span class="form-label flex-1">Facebook Account</span>
          <span class="form-value flex-1">{{ resume.facebook }}</span>
        </div>
      </div>
    </div>

    <!-- Card 3: Experience & Education -->
    <div class="cv-form-section">
      <div class="cv-section-header">
        <h3 class="cv-section-title">အတွေ့အကြုံများနှင့် အရည်အချင်းများ</h3>
      </div>

      <div class="detail-block-list">
        <div class="form-item" v-if="resume.education_detail">
          <span class="form-label flex-1">ပညာအရည်အချင်း</span>
          <span class="form-value flex-1">{{ resume.education_detail }}</span>
        </div>

        <div class="form-item" v-if="resume.other_certificate">
          <span class="form-label flex-1">အခြားအသိအမှတ်ပြု လက်မှတ်များ</span>
          <span class="form-value flex-1">{{ resume.other_certificate }}</span>
        </div>

        <div class="form-item" v-if="resume.experience_detail">
          <span class="form-label flex-1">အတွေ့အကြုံ</span>
          <span class="form-value flex-1">{{ resume.experience_detail }}</span>
        </div>

        <div class="form-item" v-if="resume.expected_salary">
          <span class="form-label flex-1">မျှော်မှန်းလစာ</span>
          <span class="form-value highlight-salary flex-1">{{ resume.expected_salary }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeDetailContent',
  props: {
    resume: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>

<style scoped src="@/assets/css/resume_detail.css"></style>

